import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { fallbackContent } from '../hooks/useContent';

const Logo = () => (
  <a href="#home" className="flex items-center gap-2.5 group">
    <img src="/vetrich-logo.png" alt="Vetrich Technologies" className="h-11 w-auto object-contain" />
    <span className="font-display font-bold text-[#12263f] text-lg tracking-tight hidden sm:block">
      VETRICH TECHNOLOGIES
    </span>
  </a>
);

const Header = ({ navItems }) => {
  const nav = navItems && navItems.length ? navItems : fallbackContent.nav;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Logo />

          <nav className="hidden lg:flex items-center gap-8">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm font-medium text-gray-700 hover:text-[#12263f] transition-colors relative after:absolute after:-bottom-1 after:left-0 after:w-0 after:h-0.5 after:bg-[#c9a227] hover:after:w-full after:transition-all after:duration-300"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="#contact"
              className="inline-flex items-center px-5 py-2.5 rounded-lg bg-[#12263f] text-sm font-semibold text-white hover:bg-[#1c3a5e] transition-all"
            >
              Get in Touch
            </a>
          </div>

          <button className="lg:hidden text-[#12263f]" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-gray-100 px-5 py-4 shadow-lg">
          <nav className="flex flex-col gap-1">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-2.5 text-[15px] font-medium text-gray-700 border-b border-gray-50"
              >
                {item.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 mt-4">
              <a href="#contact" onClick={() => setOpen(false)} className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#12263f] text-sm font-semibold text-white">
                Get in Touch
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
